import * as React from 'react';
import AzureAD, { LoginType, MsalAuthProvider } from 'react-aad-msal';
import { _PortalState } from './helpers/state';
import Menu from './Menu';
import Loading from './components/Loading';

const config = {
    auth: {
        authority: 'https://login.microsoftonline.com/tfp/bwventuresb2c.onmicrosoft.com/B2C_1_SignUpSignIn',
        clientId: 'c9355c92-83d4-4682-9240-6ef88b03712f',
        redirectUri: window.location.origin
    },
    cache: {
        // cacheLocation: "localStorage",
        storeAuthStateInCookie: true
    },

};

const authenticationParameters = {
    scopes: [
        'https://bwventuresb2c.onmicrosoft.com/portal/api_access'
    ]
}

export default class App extends React.Component<{}, IAppState> {

    constructor(props: {}) {
        super(props);
        this.state = {
            LoggedIn: false
        }

        _PortalState.authProvider = new MsalAuthProvider(config, authenticationParameters, LoginType.Redirect)
        // _PortalState.ApiEndpoint = "https://bwventures-api.azurewebsites.net";
        _PortalState.ApiEndpoint = 'https://bwventuresportal-api.azurewebsites.net';
    }


    public render() {
        return (
            <AzureAD
                provider={
                    _PortalState.authProvider
                }
                forceLogin={true}
            // unauthenticatedFunction={() => {
            //     return <Loading />;
            // }}
            // authenticatedFunction={(logout) => {
            //     if (this.state.LoggedIn) {
            //         return (
            //             <Menu logout={logout} />
            //         );
            //     } else {
            //         return <div>
            //             <Loading />
            //         </div>
            //     }
            // }}
            // accountInfoCallback={(accountInfo) => {
            //     console.log(accountInfo);
            //     _PortalState.accountInfo = accountInfo;
            //     fetch('https://bwventuresportal-api.azurewebsites.net/api/groups', {
            //         method: 'GET',
            //         headers: {
            //             'Authorization': 'Bearer ' + accountInfo.jwtAccessToken
            //         }
            //     })
            //         .then(res => res.json())
            //         .then(groups => {
            //             // _PortalState.groups = groups.groups;
            //             // this.setState({ LoggedIn: true });
            //             fetch('/videos.json')
            //                 .then(res => res.json())
            //                 .then(videos => {
            //                     _PortalState.groups = groups.groups;
            //                     _PortalState.videos = videos['videos'];
            //                     this.setState({ LoggedIn: true });
            //                 });
            //         })
            // }}
            >
                <Portal />
            </AzureAD>
        );

    }
}

interface IAppState {
    LoggedIn: boolean;
}

class Portal extends React.Component<{}, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            LoggedIn: false
        }
    }

    public async componentDidMount() {
        _PortalState.authProvider.getAccessToken().then(token => {
            fetch(_PortalState.ApiEndpoint + '/api/groups', {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token.accessToken
                }
            })
                .then(res => res.json())
                .then(groups => {
                    // _PortalState.groups = groups.groups;
                    // this.setState({ LoggedIn: true });
                    fetch('/videos.json')
                        .then(res => res.json())
                        .then(videos => {
                            _PortalState.groups = groups.groups;
                            _PortalState.videos = videos['videos'];
                            this.setState({ LoggedIn: true });
                        });
                })
        })
        
    }

    public render() {
        if (this.state.LoggedIn) {
            return (
                <Menu />
            );
        } else {
            return (
                <div>
                    <Loading />
                </div>
            )
        }
    }

}


// WEBPACK FOOTER //
// ./src/App.tsx